import React from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import FooterLogo from '../assets/footer/Footer_assets-02.png';
import Icon from '../assets/icons/Icon';
import { useDict } from '../contexts/LanguageContext';
import PrivacyNoticeEngPDF from '../documents/privacy_notice_EN.pdf';
import PrivacyNoticeThaiPDF from '../documents/privacy_notice_TH.pdf';
import TermsOfServiceEngPDF from '../documents/terms_of_service_EN.pdf';
import TermsOfServiceThaiPDF from '../documents/terms_of_service_TH.pdf';
import ROUTE_NAME from '../routes/RouteName';

const Footer = () => {
    const location = useLocation();
    const dict = useDict();
    const language = localStorage.getItem('language') === 'en' ? 'en' : 'th';

    const privacyNoticePDF = language === 'th' ? PrivacyNoticeThaiPDF : PrivacyNoticeEngPDF;
    const termsOfServicePDF = language === 'th' ? TermsOfServiceThaiPDF : TermsOfServiceEngPDF;

    const openPDFPreview = (pdfFile) => {
        window.open(pdfFile, '_blank');
    };

    switch (location.pathname) {
        case ROUTE_NAME.HOME:
        case ROUTE_NAME.REGISTRATION:
        case ROUTE_NAME.TWO_FACTOR_AUTH:
        case ROUTE_NAME.LOGOUT:
        case ROUTE_NAME.REGISTRATION_DETAILS:
            // case ROUTE_NAME.FORGOT_PASSWORD:
            // case ROUTE_NAME.RESET_PASSWORD:
            // case ROUTE_NAME.EMAIL_ACTIVATION:
            return null;
        default:
            return (
                <footer className="footer">
                    <Row className="container mx-auto footer__container g-0">
                        <Col lg={2} sm={12} xs={12} className="logo__container">
                            <img src={FooterLogo} alt="footerLogo" />
                        </Col>
                        <Col lg={8} sm={12} xs={12} className="text__container">
                            <p>
                                {dict.regulatedByText1}
                                <br />
                                {dict.regulatedByText2}
                                <br />
                                <a className="text-blue cursor-pointer" onClick={() => openPDFPreview(privacyNoticePDF)}>
                                    {dict.privacyPolicy}
                                </a>
                                {' | '}
                                <a className="text-blue cursor-pointer" onClick={() => openPDFPreview(termsOfServicePDF)}>
                                    {dict.termsOfService}
                                </a>
                            </p>
                        </Col>
                        <Col
                            lg={2}
                            sm={12}
                            xs={12}
                            className="contact-btn__container"
                        >
                            <Row className="g-0">
                                <a
                                    href="https://capbay.in.th/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="margin-right-4 contact-btn"
                                >
                                    <Icon icon="Web" width="32" />
                                </a>
                                <a
                                    href="https://www.facebook.com/capbaymy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="margin-right-4 contact-btn"
                                >
                                    <Icon icon="Facebook" width="32" />
                                </a>
                                <a
                                    href="mailto:contact-th@capbay.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-btn"
                                >
                                    <Icon icon="Mail" width="32" />
                                </a>
                            </Row>
                        </Col>
                    </Row>
                </footer>
            );
    }
};

export default Footer;
